import { useMutation, useQuery } from "@tanstack/react-query";
import { MutationOptions, QueryOptions } from "PFTypes/request_options";

import { TemplatesResponse } from "../show/types";
import { Template } from "../types";
import { editTemplate, EditTemplateArgs, fetchTemplate, fetchTemplates } from "./api";

export const useTemplatesQuery = (options: QueryOptions<TemplatesResponse> = {}) =>
  useQuery<TemplatesResponse>({
    queryKey: ["templates_list"],
    queryFn: fetchTemplates,
    staleTime: 0,
    ...options
  });

export const useTemplateQuery = (id: number, options: QueryOptions<Template> = {}) =>
  useQuery<Template, string>(["template_details", id], () => fetchTemplate(id), {
    staleTime: 0,
    ...options
  });

export const useTemplateUpdate = (options: MutationOptions<EditTemplateArgs> = {}) =>
  useMutation<Template, any, EditTemplateArgs>(["template_update"], editTemplate, options);
